import React, { createContext, useContext, useMemo, useState } from "react";
import { ReviewTab } from "./ReviewTabs";
import { CurrentMedia } from "@rapid/store/slices/mediaSlice";

interface ReviewContextValue {
    activeTab: ReviewTab;
    setActiveTab: (tab: ReviewTab) => void;
    // Stores the video's CurrentMedia when switching to annotations view so it
    // can be restored when switching back to predictions.
    savedVideoMedia: CurrentMedia | null;
    setSavedVideoMedia: (media: CurrentMedia | null) => void;
}

const ReviewContext = createContext<ReviewContextValue>({
    activeTab: ReviewTab.DraftModel,
    setActiveTab: () => {},
    savedVideoMedia: null,
    setSavedVideoMedia: () => {}
});

export const useReviewTab = () => useContext(ReviewContext);

export const ReviewContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [activeTab, setActiveTab] = useState<ReviewTab>(ReviewTab.DraftModel);
    const [savedVideoMedia, setSavedVideoMedia] = useState<CurrentMedia | null>(null);

    const value = useMemo(
        () => ({ activeTab, setActiveTab, savedVideoMedia, setSavedVideoMedia }),
        [activeTab, savedVideoMedia]
    );

    return <ReviewContext.Provider value={value}>{children}</ReviewContext.Provider>;
};
